import { j as r } from "../jsx-runtime-Bdg6XQ1m.js";
import { InfoIcon as t, LightbulbIcon as s, AlertTriangleIcon as k, ShieldAlertIcon as u } from "lucide-react";
import { c as o } from "../cn-qaFjX9_3.js";
const y = {
  note: {
    border: "border-gray-300 dark:border-zinc-800",
    bg: "bg-gray-100 dark:bg-zinc-800/50",
    iconColor: "text-gray-600 dark:text-zinc-300",
    titleColor: "text-gray-600 dark:text-zinc-300",
    textColor: "text-gray-600 dark:text-zinc-300",
    Icon: t
  },
  tip: {
    border: "border-green-500 dark:border-green-800",
    bg: "bg-green-200/25 dark:bg-green-950/70",
    iconColor: "text-green-600 dark:text-green-200",
    titleColor: "text-green-700 dark:text-green-200",
    textColor: "text-green-600 dark:text-green-50",
    Icon: s
  },
  info: {
    border: "border-blue-400 dark:border-blue-900/60",
    bg: "bg-blue-50 dark:bg-blue-950/40",
    iconColor: "text-blue-400 dark:text-blue-200",
    titleColor: "text-blue-700 dark:text-blue-200",
    textColor: "text-blue-600 dark:text-blue-100",
    Icon: t
  },
  caution: {
    border: "border-yellow-400 dark:border-yellow-400/25",
    bg: "bg-yellow-100/60 dark:bg-yellow-400/10",
    iconColor: "text-yellow-500 dark:text-yellow-300",
    titleColor: "text-yellow-600 dark:text-yellow-300",
    textColor: "text-yellow-700 dark:text-yellow-200",
    Icon: k
  },
  danger: {
    border: "border-rose-400 dark:border-rose-800",
    bg: "bg-rose-50 dark:bg-rose-950/40",
    iconColor: "text-rose-400 dark:text-rose-300",
    titleColor: "text-rose-800 dark:text-rose-300",
    textColor: "text-rose-700 dark:text-rose-100",
    Icon: u
  }
}, p = ({ type: l, children: d, title: e, className: n }) => {
  const { border: a, bg: b, iconColor: x, titleColor: c, textColor: g, Icon: i } = y[l];
  return /* @__PURE__ */ r.jsxs(
    "div",
    {
      className: o(
        "not-prose grid grid-cols-[min-content_1fr] grid-rows-[fit-content_1fr] gap-x-4 gap-y-2 text-md rounded-md border p-4",
        "[&_a]:underline [&_a]:decoration-current [&_a]:decoration-from-font [&_a]:underline-offset-4 hover:[&_a]:decoration-1",
        "[&_code]:!bg-gray-50 [&_code]:dark:!bg-gray-800 [&_code]:!border-none my-2",
        e && "items-center",
        a,
        b,
        n
      ),
      children: [
        /* @__PURE__ */ r.jsx(
          i,
          {
            className: o(!e && "translate-y-px", x),
            size: 20,
            "aria-hidden": "true"
          }
        ),
        e && /* @__PURE__ */ r.jsx("h3", { className: o("font-medium", c), children: e }),
        /* @__PURE__ */ r.jsx("div", { className: o("col-start-2", !e && "row-start-1", g), children: d })
      ]
    }
  );
};
export {
  p as Callout
};
//# sourceMappingURL=Callout.js.map
